import { render, staticRenderFns } from "./register2.vue?vue&type=template&id=e4224518&scoped=true"
import script from "./register2.vue?vue&type=script&lang=js"
export * from "./register2.vue?vue&type=script&lang=js"
import style0 from "./register2.vue?vue&type=style&index=0&id=e4224518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4224518",
  null
  
)

export default component.exports